import { useRef } from "react";
import { Block } from "@uiw/react-color";

interface ColorChangerProps {
  title: string;
  currentColor: string | undefined;
  handleColorChange: (color: { hex: string }) => void;
  onClearColor: () => void;
  icon: React.ReactNode;
}

const COLOR_PICKER_COLORS = [
  "#ffffff", // White
  "#000000", // Black
  "#e2e8f0", // Gray
  "#ff0000", // Red
  "#ff4500", // Orange Red
  "#daa520", // Golden Rod
  "#ffff33", // Yellow
  "#7fff00", // Chartreuse
  "#02f900", // Green
  "#00ffdd", // Cyan
  "#00ced1", // Dark Turquoise
  "#439ae1", // Blue
  "#8a2be2", // Blue Violet
  "#ff69b4", // Hot Pink
  "#dc143c", // Crimson
];

export default function ColorChanger({
  title,
  handleColorChange,
  onClearColor,
  currentColor,
  icon,
}: ColorChangerProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const handleOpenDialog = () => {
    dialogRef.current?.showModal();
  };

  const handleCloseDialog = () => {
    dialogRef.current?.close();
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpenDialog}
        className="p-1.5 rounded hover:bg-gray-200 text-gray-600"
        title={title}
        style={currentColor ? { color: currentColor } : undefined}
      >
        {icon}
      </button>
      <dialog
        ref={dialogRef}
        className="rounded-lg p-4 shadow-xl backdrop:bg-black/30"
      >
        <Block
          color={currentColor}
          colors={COLOR_PICKER_COLORS}
          onChange={(color) => {
            handleColorChange(color);
            handleCloseDialog();
          }}
        />
        <div className="grid grid-cols-2 gap-2 mt-2">
          <button
            type="button"
            onClick={() => {
              onClearColor();
              handleCloseDialog();
            }}
            className="px-3 py-1.5 text-xs border border-gray-300 rounded hover:bg-gray-100"
          >
            Clear
          </button>
          <button
            type="button"
            onClick={handleCloseDialog}
            className="px-3 py-1.5 text-xs border border-gray-300 rounded hover:bg-gray-100"
          >
            Close
          </button>
        </div>
      </dialog>
    </>
  );
}
